// src/components/ui/Textarea.jsx
import React, { useEffect, useRef } from "react";

/**
 * Textarea mit automatischer Höhenanpassung.
 * Startet zweizeilig und wächst dynamisch mit dem Inhalt.
 */
export default function Textarea({
  label,
  value,
  onChange,
  disabled,
  className = "",
  minRows = 2,
  maxRows = 12,
  ...props
}) {
  const ref = useRef(null);

  // automatische Höhenanpassung
  useEffect(() => {
    if (!ref.current) return;
    const textarea = ref.current;

    // Höhe zurücksetzen, dann neu anpassen
    textarea.style.height = "auto";
    const scrollHeight = textarea.scrollHeight;

    const lineHeight = 24; // entspricht etwa Tailwind px-3/py-2
    const maxHeight = maxRows * lineHeight;
    const minHeight = minRows * lineHeight;

    textarea.style.height = Math.min(Math.max(scrollHeight, minHeight), maxHeight) + "px";
  }, [value, minRows, maxRows]);

  const handleInput = (e) => {
    if (ref.current) {
      ref.current.style.height = "auto";
      const scrollHeight = ref.current.scrollHeight;

      const lineHeight = 24;
      const maxHeight = maxRows * lineHeight;
      const minHeight = minRows * lineHeight;

      ref.current.style.height = Math.min(Math.max(scrollHeight, minHeight), maxHeight) + "px";
    }
    onChange?.(e);
  };

  return (
    <div className="flex flex-col space-y-1">
      {label && <label className="text-sm text-gray-400">{label}</label>}
      <textarea
        ref={ref}
        value={value}
        onInput={handleInput}
        onChange={onChange}
        disabled={disabled}
        rows={minRows}
        className={`w-full bg-secondary-800 border border-secondary-700 text-white rounded-lg px-3 py-2 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none ${className}`}
        {...props}
      />
    </div>
  );
}
